import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0cd2922a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("title", null, "How we work, our process | Zetreex", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  name: "description",
  content: "Zetreex, Software Development Company - We own what has born in our home!"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "og:url",
  content: "https://zetreex.com/about-us"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "og:title",
  content: "How we work, our process | Zetreex"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("link", {
  rel: "canonical",
  href: "https://zetreex.com/about-us"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "og:description",
  content: "Zetreex, Software Development Company - We own what has born in our home!"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "url",
  content: "https://zetreex.com/about-us"
}, null, -1))
const _hoisted_8 = { class: "header__about" }
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "our__company" }
const _hoisted_11 = { class: "container__our_company" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Head = _resolveComponent("Head")!
  const _component_header_about = _resolveComponent("header-about")!
  const _component_advantages_company = _resolveComponent("advantages-company")!
  const _component_gifts = _resolveComponent("gifts")!
  const _component_about_employes = _resolveComponent("about-employes")!
  const _component_find_people = _resolveComponent("find-people")!
  const _component_cookies_modal = _resolveComponent("cookies-modal")!
  const _component_feed_back = _resolveComponent("feed-back")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Head, null, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _hoisted_7
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_header_about)
      ])
    ]),
    _createVNode(_component_advantages_company),
    _createVNode(_component_gifts),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_about_employes),
        _createVNode(_component_find_people)
      ])
    ]),
    _createVNode(_component_cookies_modal),
    _createVNode(_component_feed_back)
  ], 64))
}